// 调度核对趟次  - 列表
export const API_POST_TRANSPORTSETTLE_SCHEDULECHECKTIMESSELECTLIST = {
  url: 'api/tms/transportSettle/scheduleCheckTimesSelectList',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 调度核对趟次  - 数量
export const API_POST_TRANSPORTSETTLE_SCHEDULECHECKTIMESSELECTCOUNT = {
  url: 'api/tms/transportSettle/scheduleCheckTimesSelectCount',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 调度核对趟次  - 批量确认
export const API_POST_TRANSPORTSETTLE_SCHEDULECHECKTIMESBATCHCONFIRMATION = {
  url: 'api/tms/transportSettle/scheduleCheckTimesBatchConfirmation',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 调度核对趟次  - 批量拒绝
export const API_POST_TRANSPORTSETTLE_SCHEDULECHECKTIMESBATCHREJECT = {
  url: 'api/tms/transportSettle/scheduleCheckTimesBatchReject',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 查询承运商下车型名称
export const API_POST_TRANSPORTSETTLE_CARRIRTSELECTVEHICLETYPENAME = {
  url: 'api/tms/transportSettle/carrierSelectVehicleTypeName',
  config: {
    method: 'POST',
    host: 'SUPPLIER',
  },
};
